import { CandidatePersonalDetails } from '../candidate/types';
import { ChildCandidateResponse, MyProfileCandidateResponse } from '../candidate/apiTypes';

import { CandidateSummary, ChildDetails } from './types';
import { CandidateSummaryResponse, ChildDetailsResponse } from './apiTypes';

export const mapCandidateSummaryResponse = (data: CandidateSummaryResponse): CandidateSummary => ({
  candidate: mapCandidateDetailResponse(data.Candidate),
  childCandidates: data.Candidate.ChildCandidates.map(mapChildDetailResponse),
  payments: data.Payments.map((x) => ({
    amount: x.Amount,
    awardingBodyId: x.AwardingBodyId,
    balance: x.Balance,
    currencyCode: x.CurrencyCode,
    paid: x.Paid,
    paymentName: x.PaymentName,
    paymentSlipNumber: x.PaymentSlipNumber,
    productGroupSubSystemId: x.ProductGroupSubSystemId,
    reference: x.Reference,
    registrationEventTypeName: x.RegistrationEventTypeName,
    sessionId: x.SessionId,
    sessionMilestone: x.SessionMilestone,
    transactionDate: x.TransactionDate,
    transactionReference: x.TransactionReference,
    transactionId: x.TransationId,
    taxRate: x.TaxRate,
  })),
  exams: data.CandidateExams.map((x) => ({
    awardingBody: x.AwardingBody,
    candidateName: x.CandidateName,
    candidateId: x.CandidateId,
    countryId: x.CountryId,
    currencyCode: x.CurrencyCode,
    districtId: x.DistrictId,
    districtName: x.DistrictName,
    fee: x.Fee,
    id: x.Id,
    isCanceled: x.IsCanceled,
    isCarryForward: x.IsCarryForward,
    isChild: x.IsChild,
    isCurrentSession: x.IsCurrentSession,
    isGroupAward: x.IsGroupAward,
    isRetake: x.IsRetake,
    optionCode: x.OptionCode,
    onlinePaymentFee: x.OnlinePaymentFee,
    offlinePaymentFee: x.OfflinePaymentFee,
    paid: x.Paid,
    paymentSlipNumber: x.PaymentSlipNumber,
    previousCentreNumber: x.PreviousCentreNumber,
    previousCandidateNumber: x.PreviousCandidateNumber,
    qualificationLevelName: x.QualificationLevelName,
    registrationExported: x.RegistrationExported,
    registrationGroupId: x.RegistrationGroupId,
    registrationGroupReference: x.RegistrationGroupReference,
    sessionName: x.SessionName,
    sessionStageChanged: x.SessionStageChanged,
    subjectName: x.SubjectName,
    syllabusName: x.SyllabusName,
    sessionExamStart: x.SessionExamStart,
    taxRate: x.TaxRate,
    paymentName: data.Payments.find(p => p.Reference === x.RegistrationGroupReference)?.PaymentName ?? '',
  })),
  isCandidateDetailsDisabled: data.IsCandidateDetailsDisabled,
});

export const mapChildDetailsResponse = (data: ChildDetailsResponse): ChildDetails => ({
  allowedPeople: data.AllowedPeople.map((x) => ({
    familyName: x.FamilyName,
    otherNames: x.OtherNames,
    relationship: x.Relationship,
    telephone: x.Telephone,
  })),
  childCollectionOption: data.ChildCollectionOption,
  childStatementConfirmed: data.ChildStatementConfirmed,
  dateOfBirth: data.DOB,
});

const mapChildDetailResponse= (data: ChildCandidateResponse): CandidatePersonalDetails => ({
  ...mapCandidateResponseCommon(data),
  isMinorToAdultMigrationAvailable: data.IsMinorToAdultMigrationAvailable,
  isMinorToAdultMigrationInProgress: data.IsMinorToAdultMigrationInProgress,
  minorToAdultMigrationStartedBy: data.MinorToAdultMigrationStartedBy,
  minorToAdultMigrationStartedOn: data.MinorToAdultMigrationStartedOn
});

const mapCandidateDetailResponse= (data: MyProfileCandidateResponse): CandidatePersonalDetails => ({
  ...mapCandidateResponseCommon(data)
});

const mapCandidateResponseCommon = (data: MyProfileCandidateResponse | ChildCandidateResponse): CandidatePersonalDetails => ({
  id: data.Id,
  isChild: data.IsChild,
  otherNames: data.OtherNames ?? '',
  familyName: data.FamilyName ?? '',
  hasFamilyName: data.HasFamilyName,
  email: data.Email ?? '',
  dob: data.DOB ?? '',
  gender: data.Gender ?? '',
  isMinorToAdultMigrationAvailable: false,
  isMinorToAdultMigrationInProgress: false,
  minorToAdultMigrationStartedBy:'',
  minorToAdultMigrationStartedOn: '',
  address: {
    streetAddress1: data.Address?.StreetAddress1 ?? '',
    streetAddress2: data.Address?.StreetAddress2 ?? '',
    streetAddress3: data.Address?.StreetAddress3 ?? '',
    streetAddress4: data.Address?.StreetAddress4 ?? '',
    city: data.Address?.City ?? '',
    postCode: data.Address?.PostCode ?? '',
    countryId: data.Address?.CountryId.toString() ?? '',
  },
  mobile: data.Mobile ?? '',
  telephone: data.Telephone ?? '',
  uciCie: data.UciCie ?? '',
  uciEdexcel: data.UciEdexcel ?? '',
  uciAqa: data.UciAqa ?? '',
  guardianContactDetails: data.GuardianContactDetails
    ? {
        firstName: data.GuardianContactDetails.FirstName ?? '',
        lastName: data.GuardianContactDetails.LastName ?? '',
        email: data.GuardianContactDetails.Email ?? '',
        familyRelationshipId: data.GuardianContactDetails.FamilyRelationshipId?.toString() ?? '',
        familyRelationship: data.GuardianContactDetails.FamilyRelationship ?? '',
        dateOfBirth: data.GuardianContactDetails.DBO ?? '',
        mobile: data.GuardianContactDetails.Mobile ?? '',
        telephone: data.GuardianContactDetails.Telephone ?? '',
      }
    : null,
});
